module.exports = __webpack_public_path__ + "static/demo-hero-708f59cc52d03f2a730bbd37bc27530f.png";